package dairy.mynotes.reusablecomponents

import androidx.compose.foundation.layout.width
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import dairy.mynotes.ui.theme.AppColors

@Composable
fun CircularProgressBarComponent(modifier: Modifier=Modifier,width: Dp= 60.dp,
                                 progressBarColor: Color = AppColors.PrimaryVariant,
                                 trackColor: Color =  MaterialTheme.colorScheme.surfaceVariant
) {
   CircularProgressIndicator(modifier = modifier.width(width),
       color = progressBarColor,trackColor = trackColor)
}